import { Component, Input } from '@angular/core';
import { FileDownloadModel } from 'src/app/models/api/fileDownload.model';
import { ViolationsDataType } from 'src/app/models/api/violations.model';
import { ISelectedFilters } from 'src/app/models/filters/selectedFilters.interface';
import { SortColumn } from 'src/app/models/sortColumn.model';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';
import { ViolationsHttpService } from 'src/app/services/httpServices/violationsHttpService/violations-http.service';

@Component({
  selector: 'app-violations-export',
  templateUrl: './violations-export.component.html',
  styleUrls: ['./violations-export.component.scss'],
})
export class ViolationsExportComponent {
  @Input() public violationsDataType: ViolationsDataType;
  @Input() public selectedFilters: ISelectedFilters;
  @Input() public sort?: SortColumn[];

  public waitingForFile = false;
  public displayCheckMark = false;

  constructor(
    private readonly _violationsHttpService: ViolationsHttpService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  public exportToCSV(): void {
    this.waitingForFile = true;
    this._violationsHttpService
      .exportFilteredViolationsCsv(this.violationsDataType, this.selectedFilters, this.sort)
      .subscribe({
        next: (response: FileDownloadModel) => {
          // This will trigger the download
          window.open(response.fileUrl);
          this.waitingForFile = false;
        },
        error: (error) => {
          this.waitingForFile = false;
          this._httpErrorHandlerService.handle(error);
        },
      });
  }
}
